const sm4 = require('sm-crypto').sm4
const key = 'E5B9BFE4B89CE69687E58C96E4BA9132'

// 加密
function encrypt(msg) {
  let encryptData = sm4.encrypt(msg, key, {
    mode: 'ecb',
    padding: 'pkcs#5',
  })
  return encryptData
}

// 解密
function decrypt(msg) {
  let decryptData = sm4.decrypt(msg, key, {
    mode: 'ecb',
    padding: 'pkcs#5',
  })
  return decryptData
}

export { encrypt, decrypt }
